import { combineReducers } from 'redux';
import {
  GET_EDIT_SUCCESS
} from "../action-types/userInfo";

const enterPriseInfo = (state = {}, action) => {
  if (action.type === GET_EDIT_SUCCESS) {
    return { ...state, ...action.data,apiStatus:true }
  }
  return state
}
export default combineReducers({
  enterPriseInfo
})
